import { zhFun } from '@/utils';

// ===== 模块-页面统一配置 =====
// 按版本组织，每个版本定义完整的页面-模块映射
// pages[i]: { modules: 该页包含的模块名数组, validateKeys: 翻页时需要校验的字段 }
const MODULE_CONFIG = {
    gov: {
        pages: [
            { modules: ['用户的基础信息', '舌象分析', '先天健康状态'], validateKeys: [] },
            { modules: ['面象分析'], validateKeys: ['face_text'] },
            { modules: ['中医体质辨识（政府版）', '体质特征'], validateKeys: ['tizhi_text_array'] },
            { modules: ['脏腑辨证'], validateKeys: ['tizhi_zangfu'] },
            { modules: ['气血津液辨证'], validateKeys: ['tizhi_qixuejinye'] },
            { modules: ['经络辨证'], validateKeys: ['tizhi_jingluo'] },
            { modules: ['健康平衡度', '发病倾向'], validateKeys: [] },
            { modules: ['体质调理方案'], validateKeys: [] },
        ]
    },
    commercial: {
        pages: [
            { modules: ['用户的基础信息', '舌象分析', '先天健康状态'], validateKeys: [] },
            { modules: ['面象分析'], validateKeys: ['face_text'] },
            { modules: ['中医体质辨识（商业版）'], validateKeys: ['tizhi_text_array'] },
            { modules: ['五脏风险评估'], validateKeys: ['zangfu'] },
            { modules: ['经络风险评估'], validateKeys: ['jingluo'] },
            { modules: ['调理方法'], validateKeys: [] },
            { modules: ['体质调理方案'], validateKeys: [] },
        ]
    }
};

// 模块中文名 → 组件名映射
export const MODULE_COMPONENT_MAP = {
    '用户的基础信息': 'UserInfo',
    '舌象分析': 'Tongue',
    '面象分析': 'Face',
    '先天健康状态': 'Innate',
    '中医体质辨识（政府版）': 'Physique',
    '中医体质辨识（商业版）': 'PhysiqueBusiness',
    '体质特征': 'Feature',
    '脏腑辨证': 'Zangfu',
    '五脏风险评估': 'WuzangRisk',
    '气血津液辨证': 'Qixuejinye',
    '经络风险评估': 'JingluoRisk',
    '经络辨证': 'Jingluo',
    '调理方法': 'AdjustmentFun',
    '健康平衡度': 'Balance',
    '发病倾向': 'Tendency',
    '体质调理方案': 'Adjustment',
};

// 当前激活的版本
let currentVersion = 'gov';

// 切换模块版本（未来对接新版本时调用）
export function setModuleVersion(version) {
    if (MODULE_CONFIG[version]) {
        currentVersion = version;
    }
}

// 获取当前版本的页面配置
export function getPageConfig() {
    return MODULE_CONFIG[currentVersion].pages;
}

// 获取当前版本的所有模块名称（扁平化）
export function getModuleNames() {
    return getPageConfig().reduce((acc, p) => acc.concat(p.modules), []);
}

// 获取当前版本的页码校验配置（兼容原 pageConfig 格式）
export function getPageValidation() {
    return getPageConfig().map(p => p.validateKeys);
}

// 向后兼容：默认版本的所有模块名称
export const ALL_MODULE_NAMES = getModuleNames();

// 判断模块是否应该显示
// showModules: 需要显示的模块名数组；仅数组中声明过的模块才显示，为空/不传 => 全部屏蔽
export function canShowModule(name, showModules) {
    const show = Array.isArray(showModules) ? showModules : [];
    return show.indexOf(name) !== -1;
}

// BMI 文本
export function MBItext(bmi) {
    if (bmi <= 18.5) return '偏瘦';
    if (bmi >= 18.5 && bmi <= 23.9) return '正常';
    if (bmi >= 24 && bmi <= 26.9) return '偏胖';
    if (bmi >= 27 && bmi <= 29.9) return '肥胖';
    if (bmi >= 30) return '重度肥胖';
    return '';
}

export function TongueFilter(text) {
    if (text == '青紫') return '是否青紫';
    return text;
}

export function zhFilter(zh, data, sex, name) {
    return zhFun(zh, data, sex, name);
}

export function ZangFutext(level) {
    if (level == 1) return '轻度';
    if (level == 2) return '中度';
    if (level == 3) return '偏重';
    return '';
}

export function isFlowStep19(info) {
    return Number(info && info.flow_step) === 19;
}

export function isFlowStep20(info) {
    return Number(info && info.flow_step) === 20;
}

export function formatTizhiName(name) {
    return typeof name === 'string' ? name.replace(/\s*[（(](主|兼)[）)]\s*/g, '').trim() : name;
}

export function formatModuleSyndromeName(name, info) {
    return isFlowStep19(info) ? formatTizhiName(name) : name;
}

export function hasQingxiangTizhi(info) {
    return (
        isFlowStep19(info) &&
        Array.isArray(info && info.tizhi_qingxiang_text_array) &&
        info.tizhi_qingxiang_text_array.length > 0 &&
        info.tizhi_qingxiang_text_array[0] !== ''
    );
}

export function hasMainPhysique(info) {
    if (!info || !info.tizhi_content || !info.tizhi_content.physique) return false;
    const physique = info.tizhi_content.physique;
    if (!Array.isArray(physique) || physique.length === 0) return false;
    const first = physique[0];
    return typeof first === 'object' ? !!(first && first.name) : !!first;
}

export function getPhysiqueName(item) {
    if (item && typeof item === 'object') return item.name || '';
    return item || '';
}

export function isShowFun(showArray) {
    let bool = false;
    showArray.map((show) => {
        if (show.goodsURL && show.active) bool = true;
    });
    return bool;
}

// 为组件注入通用 prop 和 canShow 方法
export const moduleMixin = {
    props: {
        showModules: { type: Array, default: () => [] },
        isPrint: { type: Boolean, default: false }
    },
    methods: {
        canShow(name) {
            return canShowModule(name, this.showModules);
        }
    }
};
